import { useState, useEffect } from "react";
import API from "../api";

function Dashboard() {
  const currentMonth = new Date().toISOString().slice(0, 7);
  const [data, setData] = useState(null);
  const [monthFilter, setMonthFilter] = useState(currentMonth);

  useEffect(() => {
    fetchDashboard();
  }, [monthFilter]);

  const fetchDashboard = () => {

    let url = "order/dashboard/data/?";

    if (monthFilter) {
      url += `month=${monthFilter}`;
    }

    API.get(url).then(res => setData(res.data));
  };

  if (!data) return <div>Loading...</div>;

  return (
    <div className="container-fluid">

      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Dashboard</h4>

        <input
          type="month"
          className="form-control"
          style={{ width: "200px" }}
          value={monthFilter}
          onChange={(e) => setMonthFilter(e.target.value)}
        />
      </div>

      {/* ===================== SUMMARY CARDS ===================== */}

      <div className="row mb-4">

        <div className="col-md-4">
          <div className="card shadow-sm">
            <div className="card-body">
              <h6>Orders Today</h6>
              <h3>{data.orders_today}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card shadow-sm">
            <div className="card-body">
              <h6>Pending Items</h6>
              <h3 className="text-warning">{data.total_pending}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card shadow-sm">
            <div className="card-body">
              <h6>Done Items</h6>
              <h3 className="text-success">{data.total_done}</h3>
            </div>
          </div>
        </div>

      </div>

      <div className="row">

        {/* ===================== CUSTOMER WISE ===================== */}

        <div className="col-md-6">
          <div className="card shadow-sm mb-4">
            <div className="card-header">
              Customer Wise Orders
            </div>
            <div className="card-body p-0">
              <table className="table table-sm mb-0">
                <thead>
                  <tr>
                    <th className="ps-3">Customer</th>
                    <th>Orders</th>
                  </tr>
                </thead>
                <tbody>
                  {data.customer_wise.map((c, index) => (
                    <tr key={index}>
                      <td className="ps-3">{c.customer__name}</td>
                      <td>{c.total_orders}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* ===================== SHEET SALES ===================== */}

        <div className="col-md-6">
          <div className="card shadow-sm mb-4">
            <div className="card-header">
              Sheet Wise Sales
            </div>
            <div className="card-body p-0">
              <table className="table table-sm mb-0">
                <thead>
                  <tr>
                    <th className="ps-3">Sheet</th>
                    <th>Total Sold</th>
                  </tr>
                </thead>
                <tbody>
                  {data.sheet_sales.map((s, index) => (
                    <tr key={index}>
                      <td className="ps-3">{s.sheet__name}</td>
                      <td>{s.total_qty}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      {/* ===================== LOW STOCK ===================== */}

      <div className="card shadow-sm">
        <div className="card-header bg-danger text-white">
          Low Stock Items
        </div>
        <div className="card-body p-0">
          {data.low_stock_items.length === 0 ? (
            <div className="p-3 text-success">
              All stock levels are healthy
            </div>
          ) : (
            <table className="table table-sm mb-0">
              <thead>
                <tr>
                  <th className="ps-3">Sheet</th>
                  <th>Stock</th>
                </tr>
              </thead>
              <tbody>
                {data.low_stock_items.map((item, index) => (
                  <tr key={index}>
                    <td className="ps-3">{item.name}</td>
                    <td className="text-danger fw-bold">
                      {item.stock_sheets}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

    </div>
  );
}

export default Dashboard;
